/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { observer } from 'mobx-react-lite';
import React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';

/**
 * The placeholder for the consent banner. Fires up the
 * consent library.
 */
export const ConsentBanner = observer(() => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { rootStore, dispatcher } = useGlobalState();

    React.useEffect(() => {
        if (!rootStore.authStore.isLoading) {
            dispatcher.dispatch('initializeConsent', { rootElement: ref.current });
        }
    }, [rootStore.authStore.isLoading]);

    return !rootStore.authStore.isLoading ? <div id="consentPlaceholder" ref={ref} /> : null;
});
